// Tracks a serialized baseline and guards links, Turbo visits, history, and unloads.
export class UnsavedChangesGuard {
  constructor(controller, baseline) {
    this.controller = controller;
    this.baseline = baseline;
    this.historyIndex = window.history.state?.turbo?.restorationIndex;
  }

  disconnect() {
    clearTimeout(this.bypassTimeout);
  }

  update(snapshot) {
    this.snapshot = snapshot;
    this.dirty = snapshot !== this.baseline;
  }

  cancel() {
    this.#temporarilyBypass();
  }

  submitSucceeded(snapshot) {
    this.baseline = snapshot;
    this.update(snapshot);
  }

  confirmClick(event) {
    const link = event.target.closest('a[href]');
    const modified = event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
    if (!link || modified || link.matches(this.#ignoredLinkSelector)) return;
    this.confirmVisit(event);
  }

  confirmVisit(event) {
    if (!this.dirty || this.bypass) return;
    if (window.confirm(this.controller.messageValue)) this.#temporarilyBypass();
    else event.preventDefault();
  }

  confirmUnload(event) {
    if (!this.dirty || this.bypass) return;
    event.preventDefault();
    event.returnValue = '';
  }

  confirmModalClose(event) {
    this.confirmVisit(event);
  }

  confirmHistory(event) {
    if (this.restoring) {
      event.stopImmediatePropagation();
      this.restoring = false;
      return;
    }
    if (!this.dirty || window.confirm(this.controller.messageValue)) return;

    const targetIndex = event.state?.turbo?.restorationIndex;
    if (!Number.isInteger(this.historyIndex) || !Number.isInteger(targetIndex)) return;

    event.stopImmediatePropagation();
    this.restoring = true;
    window.history.go(this.historyIndex - targetIndex);
  }

  #temporarilyBypass() {
    clearTimeout(this.bypassTimeout);
    this.bypass = true;
    this.bypassTimeout = setTimeout(() => {
      this.bypass = false;
    }, 500);
  }

  get #ignoredLinkSelector() {
    return '[target="_blank"], [download], [data-turbo-frame="modal"], [data-onscreen-character-manager-ignore], [href^="#"], [href^="javascript:"]';
  }
}
